import { render } from "./OriginsTopCard.vue?vue&type=template&id=35c0de4a"
import script from "./OriginsTopCard.vue?vue&type=script&lang=js"
export * from "./OriginsTopCard.vue?vue&type=script&lang=js"
script.render = render

export default script